// =============================================================================
// ACT ENGLISH TEST BANK - Form 25MC1
// Source: Official ACT Prep Guide 2025-2026
// Total Questions: 50 (40 scored, 10 field test)
// =============================================================================

export const formId = '25MC1';
export const subject = 'english';
export const totalQuestions = 50;
export const scoredQuestions = 40;
export const timeLimit = 35; // minutes

// Field test questions (not scored)
export const fieldTestPositions = [41, 42, 43, 44, 45, 46, 47, 48, 49, 50];

// -----------------------------------------------------------------------------
// SCORING TABLE (40 scored questions)
// -----------------------------------------------------------------------------
export const scoringTable = {
  40: 36, 39: 35, 38: 35, 37: 33, 36: 31, 35: 29, 34: 28, 33: 27, 32: 26, 31: 25,
  30: 24, 29: 23, 28: 22, 27: 22, 26: 21, 25: 20, 24: 20, 23: 19, 22: 18, 21: 17,
  20: 16, 19: 15, 18: 15, 17: 14, 16: 13, 15: 13, 14: 12, 13: 11, 12: 11, 11: 10,
  10: 10, 9: 10, 8: 9, 7: 8, 6: 7, 5: 7, 4: 6, 3: 5, 2: 3, 1: 2, 0: 1
};

// -----------------------------------------------------------------------------
// CATEGORY DEFINITIONS
// -----------------------------------------------------------------------------
export const categories = {
  POW: { name: 'Production of Writing', description: 'Topic development, organization, unity, cohesion', count: 15 },
  KLA: { name: 'Knowledge of Language', description: 'Precise word choice, style, tone consistency', count: 8 },
  CSE: { name: 'Conventions of Standard English', description: 'Sentence structure, punctuation, usage', count: 17 }
};

// -----------------------------------------------------------------------------
// PASSAGES
// -----------------------------------------------------------------------------
export const passages = [
  {
    id: 'P1',
    title: 'Alex Atala and Brazilian Cuisine',
    type: 'informational',
    questionRange: [1, 10]
  },
  {
    id: 'P2', 
    title: 'Rediscovering Hrosvitha',
    type: 'informational',
    questionRange: [11, 15]
  },
  {
    id: 'P3',
    title: 'A Musical Detour',
    type: 'narrative',
    questionRange: [16, 25]
  },
  {
    id: 'P4',
    title: 'The Case for Visible Storage',
    type: 'informational',
    questionRange: [26, 35]
  },
  {
    id: 'P5',
    title: "The Sociable Weavers' Complex Nest",
    type: 'informational',
    questionRange: [36, 40]
  },
  {
    id: 'P6',
    title: 'The Artful Stitch of Paj Ntaub',
    type: 'informational',
    questionRange: [41, 50]
  }
];

// -----------------------------------------------------------------------------
// QUESTIONS
// -----------------------------------------------------------------------------
export const questions = [
  // PASSAGE I: Alex Atala and Brazilian Cuisine (Q1-10)
  {
    id: '25MC1-E01',
    formId: '25MC1',
    questionNumber: 1,
    passageId: 'P1',
    category: 'CSE',
    subcategory: 'Sentence Structure',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'At first, Brazilian chef Alex Atala opened his',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'Years ago,' },
      { letter: 'C', text: 'When' },
      { letter: 'D', text: 'Delete the underlined portion.' }
    ],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: '"When" properly introduces a dependent clause that connects to the main clause about people telling him he\'d never succeed.'
  },
  {
    id: '25MC1-E02',
    formId: '25MC1',
    questionNumber: 2,
    passageId: 'P1',
    category: 'CSE',
    subcategory: 'Punctuation',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'ingredients, such as, manioc root',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'ingredients—such as manioc root' },
      { letter: 'H', text: 'ingredients such as—manioc root' },
      { letter: 'J', text: 'ingredients such as, manioc root,' }
    ],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'Em dashes properly set off the parenthetical list. No comma is needed after "such as."'
  },
  {
    id: '25MC1-E03',
    formId: '25MC1',
    questionNumber: 3,
    passageId: 'P1',
    category: 'POW',
    subcategory: 'Word Choice',
    difficulty: 2,
    isScored: true,
    question: 'The writer wants to emphasize the positive experience diners have had at Atala\'s restaurant. Which choice best accomplishes that goal?',
    underlinedText: 'thrilled',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'mystified' },
      { letter: 'C', text: 'shocked' },
      { letter: 'D', text: 'startled' }
    ],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: '"Thrilled" is the most clearly positive word. The other options suggest confusion or surprise rather than delight.'
  },
  {
    id: '25MC1-E04',
    formId: '25MC1',
    questionNumber: 4,
    passageId: 'P1',
    category: 'POW',
    subcategory: 'Transitions',
    difficulty: 2,
    isScored: true,
    question: 'Given that all the choices are accurate, which one provides the best transition from the preceding paragraph to this paragraph?',
    underlinedText: 'Still, Atala felt he could do more for his country and its cuisine.',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'Atala is known for sometimes incorporating fragrances into his dishes as well.' },
      { letter: 'H', text: 'In fact, Atala\'s culinary training took place in classic European restaurants.' },
      { letter: 'J', text: 'Atala\'s obvious affection for his homeland is said to be infectious.' }
    ],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: 'The original provides the best transition by acknowledging his success while introducing his desire to do more.'
  },
  {
    id: '25MC1-E05',
    formId: '25MC1',
    questionNumber: 5,
    passageId: 'P1',
    category: 'CSE',
    subcategory: 'Pronoun Agreement',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'the tree dies once its large heart is removed',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'tree dies once their' },
      { letter: 'C', text: 'trees die once its' },
      { letter: 'D', text: 'tree dies once it\'s' }
    ],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'The singular "tree" requires the singular possessive pronoun "its." "It\'s" is a contraction of "it is."'
  },
  {
    id: '25MC1-E06',
    formId: '25MC1',
    questionNumber: 6,
    passageId: 'P1',
    category: 'KLA',
    subcategory: 'Style and Tone',
    difficulty: 2,
    isScored: true,
    question: 'Which choice most effectively maintains the essay\'s tone?',
    underlinedText: 'live to yield more hearts',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'pull through and spawn' },
      { letter: 'H', text: 'continue to churn out' },
      { letter: 'J', text: 'keep doling out' }
    ],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: 'The original maintains the formal, informative tone of the passage. The other options are too casual or informal.'
  },
  {
    id: '25MC1-E07',
    formId: '25MC1',
    questionNumber: 7,
    passageId: 'P1',
    category: 'KLA',
    subcategory: 'Concision',
    difficulty: 2,
    isScored: true,
    question: 'Which choice is least redundant in context?',
    underlinedText: 'Utilizing their historical know-how they have',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'knowledge that tribe members know about local plants,' },
      { letter: 'C', text: 'knowledge of local plants in the area,' },
      { letter: 'D', text: 'knowledge of local plants,' }
    ],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'Choice D eliminates the redundancy. "Know-how they have" and "knowledge that tribe members know" are redundant.'
  },
  {
    id: '25MC1-E08',
    formId: '25MC1',
    questionNumber: 8,
    passageId: 'P1',
    category: 'CSE',
    subcategory: 'Modifiers',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'for centuries that use indigenous agricultural techniques',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'centuries, which use' },
      { letter: 'H', text: 'centuries who use' },
      { letter: 'J', text: 'centuries, using' }
    ],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'The participial phrase "using" correctly modifies the Baniwa women\'s farming practices.'
  },
  {
    id: '25MC1-E09',
    formId: '25MC1',
    questionNumber: 9,
    passageId: 'P1',
    category: 'CSE',
    subcategory: 'Subject-Verb Agreement',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'have enabled',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'has enabled' },
      { letter: 'C', text: 'are enabling' },
      { letter: 'D', text: 'enable' }
    ],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'The subject "Partnering with Instituto Atá" is a gerund phrase (singular), requiring the singular verb "has enabled."'
  },
  {
    id: '25MC1-E10',
    formId: '25MC1',
    questionNumber: 10,
    passageId: 'P1',
    category: 'KLA',
    subcategory: 'Word Choice',
    difficulty: 2,
    isScored: true,
    question: 'Which choice is clearest and most precise in context?',
    underlinedText: 'deciphering',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'transforming' },
      { letter: 'H', text: 'dislocating' },
      { letter: 'J', text: 'contorting' }
    ],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: '"Transforming" best captures Atala\'s active role in changing and elevating Brazilian food culture.'
  },

  // PASSAGE II: Rediscovering Hrosvitha (Q11-15)
  {
    id: '25MC1-E11',
    formId: '25MC1',
    questionNumber: 11,
    passageId: 'P2',
    category: 'CSE',
    subcategory: 'Punctuation',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'Hrosvitha, a medieval author and dramatist—is',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'author and dramatist,' },
      { letter: 'C', text: 'author, and dramatist' },
      { letter: 'D', text: 'author and dramatist' }
    ],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'Two commas are needed to set off the appositive phrase "a medieval author and dramatist."'
  },
  {
    id: '25MC1-E12',
    formId: '25MC1',
    questionNumber: 12,
    passageId: 'P2',
    category: 'CSE',
    subcategory: 'Sentence Structure',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'the abbey at Gandersheim, it was well known',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'Gandersheim and, historically, this abbey was' },
      { letter: 'H', text: 'Gandersheim, it was an abbey' },
      { letter: 'J', text: 'Gandersheim, an abbey' }
    ],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Choice J uses an appositive to provide additional information about Gandersheim, avoiding a comma splice.'
  },
  {
    id: '25MC1-E13',
    formId: '25MC1',
    questionNumber: 13,
    passageId: 'P2',
    category: 'KLA',
    subcategory: 'Style and Tone',
    difficulty: 2,
    isScored: true,
    question: 'Which choice most effectively maintains the essay\'s tone?',
    underlinedText: 'made it okay for her to keep her',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'permitted her to hang on to' },
      { letter: 'C', text: 'allowed her to retain' },
      { letter: 'D', text: 'let her keep up' }
    ],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: '"Allowed her to retain" maintains the formal, academic tone appropriate for this historical essay.'
  },
  {
    id: '25MC1-E14',
    formId: '25MC1',
    questionNumber: 14,
    passageId: 'P2',
    category: 'POW',
    subcategory: 'Transitions',
    difficulty: 2,
    isScored: true,
    question: 'Which transition word or phrase is most logical in context?',
    underlinedText: 'Nevertheless',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'On the other hand,' },
      { letter: 'H', text: 'As a result,' },
      { letter: 'J', text: 'In contrast,' }
    ],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: '"As a result" shows the logical consequence: because she didn\'t have obligations to husband and children, she had greater independence.'
  },
  {
    id: '25MC1-E15',
    formId: '25MC1',
    questionNumber: 15,
    passageId: 'P2',
    category: 'POW',
    subcategory: 'Purpose',
    difficulty: 2,
    isScored: true,
    question: 'Which choice best helps indicate that each historical epic covered different subject matter?',
    underlinedText: '(about the court of Otto I and Gandersheim)',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: '(each focused on the court of Otto I and' },
      { letter: 'C', text: '(focusing on the court of Otto I as well as' },
      { letter: 'D', text: '(one about the court of Otto I, the other about' }
    ],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'Choice D clearly indicates that each epic had different subject matter by specifying "one about... the other about."'
  },

  // PASSAGE III: A Musical Detour (Q16-25)
  {
    id: '25MC1-E16',
    formId: '25MC1',
    questionNumber: 16,
    passageId: 'P3',
    category: 'CSE',
    subcategory: 'Punctuation',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'onto a stretch of Route 66 that is, surrounded by',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'highway onto a stretch of Route 66, that is,' },
      { letter: 'H', text: 'highway onto a stretch, of Route 66 that is' },
      { letter: 'J', text: 'highway onto a stretch of Route 66 that is' }
    ],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'No commas are needed in this restrictive clause identifying which stretch of Route 66.'
  },
  {
    id: '25MC1-E17',
    formId: '25MC1',
    questionNumber: 17,
    passageId: 'P3',
    category: 'KLA',
    subcategory: 'Concision',
    difficulty: 2,
    isScored: true,
    question: 'Which choice is least redundant in context?',
    underlinedText: 'into the rearview mirror, windows rolled down',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'into the rearview mirror, three miles into our detour,' },
      { letter: 'C', text: 'behind me by looking into the rearview mirror,' },
      { letter: 'D', text: 'into the rearview mirror,' }
    ],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'Choice D eliminates redundancy; the windows being rolled down was already mentioned earlier.'
  },
  {
    id: '25MC1-E18',
    formId: '25MC1',
    questionNumber: 18,
    passageId: 'P3',
    category: 'POW',
    subcategory: 'Purpose',
    difficulty: 2,
    isScored: true,
    question: 'If the writer were to delete the underlined portion (adjusting the punctuation as needed), the paragraph would primarily lose:',
    underlinedText: 'when you drive over them—like a built-in alarm for drivers who drift too close to the road\'s edge. These strips',
    choices: [
      { letter: 'F', text: 'information that indicates how prevalent rumble strips are on roadways.' },
      { letter: 'G', text: 'a detail that reveals the narrator\'s opinion of distracted drivers.' },
      { letter: 'H', text: 'information that clarifies a primary function of rumble strips.' },
      { letter: 'J', text: 'a detail that indicates what the rumble strips look like.' }
    ],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'The underlined portion explains the primary function of rumble strips as a safety warning system.'
  },
  {
    id: '25MC1-E19',
    formId: '25MC1',
    questionNumber: 19,
    passageId: 'P3',
    category: 'KLA',
    subcategory: 'Concision',
    difficulty: 2,
    isScored: true,
    question: 'Which choice is least redundant in context?',
    underlinedText: 'City planners wanted to find out whether',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'were implemented just outside Albuquerque.' },
      { letter: 'C', text: 'that play music were put in.' },
      { letter: 'D', text: 'were added a couple years ago.' }
    ],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'The original provides the necessary context about why the strips were installed.'
  },
  {
    id: '25MC1-E20',
    formId: '25MC1',
    questionNumber: 20,
    passageId: 'P3',
    category: 'POW',
    subcategory: 'Transitions',
    difficulty: 2,
    isScored: true,
    question: 'Given that all the choices are accurate, which one most effectively leads into the rest of the essay?',
    underlinedText: 'there are currently no plans to restore the strips',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'lots of other drivers, not just me, still make this detour to hear the tune.' },
      { letter: 'H', text: 'sometimes drivers will turn around and drive over the strips again.' },
      { letter: 'J', text: 'this detour on our drive home never fails to buoy my spirits.' }
    ],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Choice J provides the best transition to the concluding personal reflection about the narrator\'s experience.'
  },
  {
    id: '25MC1-E21',
    formId: '25MC1',
    questionNumber: 21,
    passageId: 'P3',
    category: 'CSE',
    subcategory: 'Verb Tense',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'After the last one of the notes fades into the darkening',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'have disappeared' },
      { letter: 'C', text: 'disappear' },
      { letter: 'D', text: 'fade' }
    ],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'The singular subject "the last one of the notes" requires the singular verb "fades."'
  },
  {
    id: '25MC1-E22',
    formId: '25MC1',
    questionNumber: 22,
    passageId: 'P3',
    category: 'CSE',
    subcategory: 'Pronouns',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'who have been lulled',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'whom have' },
      { letter: 'H', text: 'they have' },
      { letter: 'J', text: 'whose' }
    ],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: '"Who" is the correct subject pronoun for the relative clause describing the boys.'
  },
  {
    id: '25MC1-E23',
    formId: '25MC1',
    questionNumber: 23,
    passageId: 'P3',
    category: 'POW',
    subcategory: 'Transitions',
    difficulty: 2,
    isScored: true,
    question: 'Which transition word or phrase is most logical in context?',
    underlinedText: 'Until then',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'Now and then,' },
      { letter: 'C', text: 'For now,' },
      { letter: 'D', text: 'Later,' }
    ],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: '"For now" indicates a temporary state of contentment during this moment.'
  },
  {
    id: '25MC1-E24',
    formId: '25MC1',
    questionNumber: 24,
    passageId: 'P3',
    category: 'POW',
    subcategory: 'Adding/Deleting',
    difficulty: 2,
    isScored: true,
    question: 'At this point, the writer is considering adding the following accurate sentence: "I hear there is another musical road in the US, somewhere in California." Should the writer make this addition?',
    choices: [
      { letter: 'F', text: 'Yes, because it makes clear that the narrator has plans to travel on other musical roads.' },
      { letter: 'G', text: 'Yes, because it indicates that the musical road in New Mexico is not unique.' },
      { letter: 'H', text: 'No, because it draws the focus away from the New Mexico musical road and its effect on the narrator.' },
      { letter: 'J', text: 'No, because it fails to provide specific details about the construction of the musical road in California.' }
    ],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'Adding this sentence would distract from the personal, reflective conclusion about the narrator\'s experience.'
  },
  {
    id: '25MC1-E25',
    formId: '25MC1',
    questionNumber: 25,
    passageId: 'P3',
    category: 'POW',
    subcategory: 'Organization',
    difficulty: 2,
    isScored: true,
    question: 'The writer wants to add the following sentence to the essay: "It is marvelously quiet." The sentence would most logically be placed at:',
    choices: [
      { letter: 'A', text: 'Point A in Paragraph 1.' },
      { letter: 'B', text: 'Point B in Paragraph 2.' },
      { letter: 'C', text: 'Point C in Paragraph 3.' },
      { letter: 'D', text: 'Point D in Paragraph 4.' }
    ],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'The sentence about quietness fits best after the music fades in Paragraph 4, describing the peaceful moment.'
  },

  // PASSAGE IV: The Case for Visible Storage (Q26-35)
  {
    id: '25MC1-E26',
    formId: '25MC1',
    questionNumber: 26,
    passageId: 'P4',
    category: 'POW',
    subcategory: 'Purpose',
    difficulty: 2,
    isScored: true,
    question: 'If the writer were to delete the underlined portion, the essay would primarily lose a:',
    underlinedText: '(legal and ethical management, care, documentation, and use)',
    choices: [
      { letter: 'F', text: 'suggestion that not all public museums provide proper stewardship for their artifacts.' },
      { letter: 'G', text: 'clarification of what public museum stewardship entails.' },
      { letter: 'H', text: 'list of reasons for educating the public on stewardship.' },
      { letter: 'J', text: 'description of the daily tasks performed by curators.' }
    ],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'The parenthetical defines stewardship by listing what it includes.'
  },
  {
    id: '25MC1-E27',
    formId: '25MC1',
    questionNumber: 27,
    passageId: 'P4',
    category: 'CSE',
    subcategory: 'Sentence Structure',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'When displaying such a small portion of',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'With the display of' },
      { letter: 'C', text: 'While displaying' },
      { letter: 'D', text: 'Displaying' }
    ],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'The gerund phrase "Displaying" correctly introduces the subject of the sentence.'
  },
  {
    id: '25MC1-E28',
    formId: '25MC1',
    questionNumber: 28,
    passageId: 'P4',
    category: 'CSE',
    subcategory: 'Sentence Structure',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'visible storage provides ways to display',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'storage makes providing' },
      { letter: 'H', text: 'storage, which provides' },
      { letter: 'J', text: 'storage, providing' }
    ],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: 'The original clearly states what visible storage does.'
  },
  {
    id: '25MC1-E29',
    formId: '25MC1',
    questionNumber: 29,
    passageId: 'P4',
    category: 'CSE',
    subcategory: 'Pronouns',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'between it and the other objects',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'between them' },
      { letter: 'C', text: 'among them' },
      { letter: 'D', text: 'among it' }
    ],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: '"Between it and the other objects" correctly uses "between" for the relationship between one artifact and others.'
  },
  {
    id: '25MC1-E30',
    formId: '25MC1',
    questionNumber: 30,
    passageId: 'P4',
    category: 'POW',
    subcategory: 'Transitions',
    difficulty: 2,
    isScored: true,
    question: 'Which transition word is most logical in context?',
    underlinedText: 'Subsequently',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'Conversely,' },
      { letter: 'H', text: 'Namely,' },
      { letter: 'J', text: 'Granted,' }
    ],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: '"Conversely" signals the contrast between traditional displays and visible storage.'
  },
  {
    id: '25MC1-E31',
    formId: '25MC1',
    questionNumber: 31,
    passageId: 'P4',
    category: 'CSE',
    subcategory: 'Sentence Structure',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'Ceramic pottery where it might otherwise',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'that which' },
      { letter: 'C', text: 'that' },
      { letter: 'D', text: 'Delete the underlined portion.' }
    ],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: '"That" correctly introduces the relative clause modifying "Ceramic pottery."'
  },
  {
    id: '25MC1-E32',
    formId: '25MC1',
    questionNumber: 32,
    passageId: 'P4',
    category: 'POW',
    subcategory: 'Adding/Deleting',
    difficulty: 2,
    isScored: true,
    question: 'At this point, the writer is considering adding the following parenthetical phrase: "(whether because of light sensitivity or the request of a donor)" Given that the information is accurate, should the writer make this addition here?',
    choices: [
      { letter: 'F', text: 'Yes, because it gives specific examples to help explain why some objects can never be displayed in a museum.' },
      { letter: 'G', text: 'Yes, because it offers specific examples of items that require special storage.' },
      { letter: 'H', text: 'No, because it detracts from the paragraph\'s focus on the ideal museum layout.' },
      { letter: 'J', text: 'No, because it diminishes the role museums play in educating the public.' }
    ],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: 'The addition provides helpful context for why some artifacts cannot be displayed.'
  },
  {
    id: '25MC1-E33',
    formId: '25MC1',
    questionNumber: 33,
    passageId: 'P4',
    category: 'CSE',
    subcategory: 'Punctuation',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'can—and should—be viewed',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'can and should—' },
      { letter: 'C', text: 'can, and should' },
      { letter: 'D', text: 'can and, should' }
    ],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'Em dashes correctly set off the parenthetical "and should" for emphasis.'
  },
  {
    id: '25MC1-E34',
    formId: '25MC1',
    questionNumber: 34,
    passageId: 'P4',
    category: 'KLA',
    subcategory: 'Word Choice',
    difficulty: 2,
    isScored: true,
    question: 'Which choice is clearest and most precise in context?',
    underlinedText: 'Whereas',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'Although' },
      { letter: 'H', text: 'When' },
      { letter: 'J', text: 'Since' }
    ],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: '"When" introduces a conditional clause about what happens if a museum designates areas for visible storage.'
  },
  {
    id: '25MC1-E35',
    formId: '25MC1',
    questionNumber: 35,
    passageId: 'P4',
    category: 'POW',
    subcategory: 'Organization',
    difficulty: 2,
    isScored: true,
    question: 'The writer wants to add the following sentence to the essay: "This potentially compromises stewardship." For the sake of logic and cohesion, the sentence should be placed at:',
    choices: [
      { letter: 'A', text: 'Point A in Paragraph 1.' },
      { letter: 'B', text: 'Point B in Paragraph 2.' },
      { letter: 'C', text: 'Point C in Paragraph 2.' },
      { letter: 'D', text: 'Point D in Paragraph 3.' }
    ],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'The sentence about compromised stewardship logically follows the discussion of storage challenges in Paragraph 1.'
  },

  // PASSAGE V: The Sociable Weavers' Complex Nest (Q36-40)
  {
    id: '25MC1-E36',
    formId: '25MC1',
    questionNumber: 36,
    passageId: 'P5',
    category: 'POW',
    subcategory: 'Purpose',
    difficulty: 2,
    isScored: true,
    question: 'If the writer were to delete the phrase "which can measure up to thirteen feet wide and seven feet thick" from the preceding sentence (adjusting the punctuation as needed), the sentence would primarily lose:',
    choices: [
      { letter: 'F', text: 'specific information that illustrates the minimum height at which the weavers begin building their nests.' },
      { letter: 'G', text: 'specific information that underscores the enormousness of the weavers\' nests.' },
      { letter: 'H', text: 'details that clarify how the weavers are able to survive in the Kalahari Desert.' },
      { letter: 'J', text: 'details that explain how the weavers\' nests differ from other birds\' nests.' }
    ],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'The specific dimensions emphasize how enormous the nests are.'
  },
  {
    id: '25MC1-E37',
    formId: '25MC1',
    questionNumber: 37,
    passageId: 'P5',
    category: 'POW',
    subcategory: 'Word Choice',
    difficulty: 2,
    isScored: true,
    question: 'The writer wants to emphasize the unusual appearance of the weavers\' nests by using playful language to evoke a specific image. Which choice best accomplishes this goal?',
    underlinedText: 'disorganized piles',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'carelessly plunked-down haystacks.' },
      { letter: 'C', text: 'collections of disparate items.' },
      { letter: 'D', text: 'large knots.' }
    ],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: '"Carelessly plunked-down haystacks" uses playful, vivid language to describe the nests\' appearance.'
  },
  {
    id: '25MC1-E38',
    formId: '25MC1',
    questionNumber: 38,
    passageId: 'P5',
    category: 'CSE',
    subcategory: 'Sentence Structure',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'nest, it squeezes through',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'then squeezes' },
      { letter: 'H', text: 'squeezing' },
      { letter: 'J', text: 'to squeeze' }
    ],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'The present participle "squeezing" creates a parallel structure with "flying" and "continuing."'
  },
  {
    id: '25MC1-E39',
    formId: '25MC1',
    questionNumber: 39,
    passageId: 'P5',
    category: 'KLA',
    subcategory: 'Concision',
    difficulty: 2,
    isScored: true,
    question: 'Which choice is least redundant in context?',
    underlinedText: 'as a group together when the Kalahari nights get cold',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'all together, staying warm when the temperature drops and gets colder at night.' },
      { letter: 'C', text: 'and stay warm when temperatures plummet at night and it\'s cold.' },
      { letter: 'D', text: 'for warmth during the cold Kalahari nights.' }
    ],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'Choice D is concise and eliminates the redundancy of "as a group together."'
  },
  {
    id: '25MC1-E40',
    formId: '25MC1',
    questionNumber: 40,
    passageId: 'P5',
    category: 'CSE',
    subcategory: 'Homophones',
    difficulty: 2,
    isScored: true,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'at there most effective',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'when its at it\'s' },
      { letter: 'H', text: 'at it\'s' },
      { letter: 'J', text: 'at its' }
    ],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: '"Its" is the possessive pronoun; "it\'s" is a contraction of "it is." "There" should be "their" but the correct answer uses "its."'
  },

  // PASSAGE VI: The Artful Stitch of Paj Ntaub (Q41-50) - FIELD TEST QUESTIONS
  {
    id: '25MC1-E41',
    formId: '25MC1',
    questionNumber: 41,
    passageId: 'P6',
    category: 'POW',
    subcategory: 'Style',
    difficulty: 2,
    isScored: false,
    question: 'Which choice best maintains the stylistic pattern of descriptions established earlier in the sentence?',
    underlinedText: 'dizzying mazes of lines—embroidering them in vibrant',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'something with a dizzying effect—' },
      { letter: 'C', text: 'mazes that she creates—' },
      { letter: 'D', text: 'so many lines—' }
    ],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'The original maintains the descriptive pattern established earlier in the sentence.'
  },
  {
    id: '25MC1-E42',
    formId: '25MC1',
    questionNumber: 42,
    passageId: 'P6',
    category: 'CSE',
    subcategory: 'Possessives',
    difficulty: 2,
    isScored: false,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'the century\'s-oldest Hmong needlework arts',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'centuries-old' },
      { letter: 'H', text: 'centuries\'-old' },
      { letter: 'J', text: 'century\'s-old' }
    ],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: '"Centuries-old" is the correct compound adjective form.'
  },
  {
    id: '25MC1-E43',
    formId: '25MC1',
    questionNumber: 43,
    passageId: 'P6',
    category: 'POW',
    subcategory: 'Adding/Deleting',
    difficulty: 2,
    isScored: false,
    question: 'The writer is considering deleting the underlined sentence. Should the sentence be kept or deleted?',
    underlinedText: 'Paj ntaub is increasingly made in lighter, softer shades today.',
    choices: [
      { letter: 'A', text: 'Kept, because it compares Pang Xiong\'s embroidery style with that of modern paj ntaub.' },
      { letter: 'B', text: 'Kept, because it places the subject of the essay in a modern context.' },
      { letter: 'C', text: 'Deleted, because it detracts from the paragraph\'s focus on the various styles of ancient Hmong needlework arts.' },
      { letter: 'D', text: 'Deleted, because it adds a detail that is irrelevant to the paragraph\'s introduction of Pang Xiong\'s connection to paj ntaub.' }
    ],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'The sentence about modern color trends distracts from the introduction of Pang Xiong.'
  },
  {
    id: '25MC1-E44',
    formId: '25MC1',
    questionNumber: 44,
    passageId: 'P6',
    category: 'CSE',
    subcategory: 'Modifier Placement',
    difficulty: 2,
    isScored: false,
    question: 'The best placement for the underlined portion would be:',
    underlinedText: 'Flower cloth (commonly as a shirt,',
    choices: [
      { letter: 'F', text: 'where it is now.' },
      { letter: 'G', text: 'after the word made.' },
      { letter: 'H', text: 'after the word clothing.' },
      { letter: 'J', text: 'after the word needlework.' }
    ],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'The parenthetical clarification about garment types fits best after "clothing."'
  },
  {
    id: '25MC1-E45',
    formId: '25MC1',
    questionNumber: 45,
    passageId: 'P6',
    category: 'POW',
    subcategory: 'Focus',
    difficulty: 2,
    isScored: false,
    question: 'Which choice most clearly builds on the information provided earlier in the sentence about a common theme in paj ntaub patterns and images?',
    underlinedText: 'paj ntaub patterns are versatile',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'only a master artist is able to create paj ntaub clothing for special occasions.' },
      { letter: 'C', text: 'paj ntaub patterns are extraordinarily colorful.' },
      { letter: 'D', text: 'paj ntaub celebrates the natural world.' }
    ],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: '"Paj ntaub celebrates the natural world" builds on the mention of animal names like "elephant\'s foot" and "snail house."'
  },
  {
    id: '25MC1-E46',
    formId: '25MC1',
    questionNumber: 46,
    passageId: 'P6',
    category: 'CSE',
    subcategory: 'Punctuation',
    difficulty: 2,
    isScored: false,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'reverse appliqué, in which shapes',
    choices: [
      { letter: 'F', text: 'No Change' },
      { letter: 'G', text: 'appliqué which' },
      { letter: 'H', text: 'appliqué and' },
      { letter: 'J', text: 'appliqué,' }
    ],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: 'The comma before "in which" correctly introduces the nonrestrictive clause defining reverse appliqué.'
  },
  {
    id: '25MC1-E47',
    formId: '25MC1',
    questionNumber: 47,
    passageId: 'P6',
    category: 'CSE',
    subcategory: 'Pronoun Reference',
    difficulty: 2,
    isScored: false,
    question: 'Which choice makes the sentence most grammatically acceptable?',
    underlinedText: 'applied to its surface',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'the surface of the fabric.' },
      { letter: 'C', text: 'the surface of it.' },
      { letter: 'D', text: 'their surface.' }
    ],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: '"The surface of the fabric" provides a clear antecedent, avoiding ambiguous pronoun reference.'
  },
  {
    id: '25MC1-E48',
    formId: '25MC1',
    questionNumber: 48,
    passageId: 'P6',
    category: 'KLA',
    subcategory: 'Word Choice',
    difficulty: 2,
    isScored: false,
    question: 'The writer is considering revising the underlined portion to the following: "mass-produced" Should the writer make this revision?',
    underlinedText: 'regular clothes',
    choices: [
      { letter: 'F', text: 'Yes, because the revision creates a clearer contrast between the homogeneous styles of clothing that are popular today and the handcrafted paj ntaub.' },
      { letter: 'G', text: 'Yes, because the revision emphasizes Pang Xiong\'s desire for her handcrafted paj ntaub to be sold on a large scale in stores.' },
      { letter: 'H', text: 'No, because the original word reinforces the idea that although paj ntaub clothing can be used for everyday wear, it should be saved for special occasions.' },
      { letter: 'J', text: 'No, because the original word more specifically describes the type of clothing Pang Xiong disapproves of.' }
    ],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: '"Mass-produced" creates a clearer contrast with handcrafted paj ntaub.'
  },
  {
    id: '25MC1-E49',
    formId: '25MC1',
    questionNumber: 49,
    passageId: 'P6',
    category: 'POW',
    subcategory: 'Transitions',
    difficulty: 2,
    isScored: false,
    question: 'Which transition word or phrase, if any, is most logical in context?',
    underlinedText: 'However, she',
    choices: [
      { letter: 'A', text: 'No Change' },
      { letter: 'B', text: 'For example, she' },
      { letter: 'C', text: 'Besides, she' },
      { letter: 'D', text: 'She' }
    ],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'No transition is needed; the sentence continues the thought about Pang Xiong\'s personal practice.'
  },
  {
    id: '25MC1-E50',
    formId: '25MC1',
    questionNumber: 50,
    passageId: 'P6',
    category: 'POW',
    subcategory: 'Adding',
    difficulty: 2,
    isScored: false,
    question: 'Which of the following true statements, if added here, would best build on the ideas presented in this paragraph and connect to the final sentence of the essay?',
    choices: [
      { letter: 'F', text: 'She loves when people, no matter what their ethnicity, wear traditional clothing every day.' },
      { letter: 'G', text: 'She often teaches paj ntaub to Hmong adults her age who want to learn new techniques.' },
      { letter: 'H', text: 'Recently, she worked with nine young Hmong women in a formal apprenticeship.' },
      { letter: 'J', text: 'One of her own favorite pieces tells the story of her family.' }
    ],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'Working with young women in an apprenticeship connects to the final sentence about showing a new generation the joys of paj ntaub.'
  }
];

// -----------------------------------------------------------------------------
// METADATA
// -----------------------------------------------------------------------------
export const metadata = {
  formId: '25MC1',
  subject: 'english',
  source: 'Official ACT Prep Guide 2025-2026',
  totalQuestions: 50,
  scoredQuestions: 40,
  fieldTestCount: 10,
  timeLimit: 35,
  passageCount: 6,
  categories: ['POW', 'KLA', 'CSE'],
  categoryBreakdown: {
    POW: 15,
    KLA: 8,
    CSE: 17
  }
};

// -----------------------------------------------------------------------------
// HELPER FUNCTIONS
// -----------------------------------------------------------------------------
export function getQuestionsByPassage(passageId) {
  return questions.filter(q => q.passageId === passageId);
}

export function getScoredQuestions() {
  return questions.filter(q => q.isScored);
}

export function getQuestionsByCategory(category) {
  return questions.filter(q => q.category === category);
}

export function calculateScaledScore(rawScore) {
  return scoringTable[rawScore] || 1;
}

console.log(`English Test Bank 25MC1 Loaded: ${questions.length} questions (${getScoredQuestions().length} scored)`);
